// extracted by mini-css-extract-plugin
module.exports = {"credits":"Credits-module--credits--H69nL"};